// The player's pinned env, kept with Preferences. It isn't a secret, so it doesn't need secure storage.
import type { EnvStore } from "./net/env";
import { loadJson, saveJson } from "./storage";

const ENV_KEY = "env";

export const envStore: EnvStore = {
  async get() {
    const value = await loadJson(ENV_KEY);
    return typeof value === "string" ? value : undefined;
  },
  set: (env) => saveJson(ENV_KEY, env),
};
